<template>
  <a-modal v-model:visible="visible"
           :title="$t('DesignShare.DssShoppingCartModal.title')"
           :cancel-button-props="{ style: { display: 'none' } }"
           :ok-text="$t('DesignShare.DssShoppingCartModal.okText')"
           :destroy-on-close="true"
           :body-style="{ padding: '24px' }"
           :width="1100"
           @ok="onAdd"
           @cancel="onReset">
    <DssAddToCart ref="dssAddToCart" />
  </a-modal>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { getThemeCustomSpuData } from "../../api"
import type { CustomSpu } from '../../configure'
import DssAddToCart from '../DssAddToCart.vue'

const visible = ref(false)

const dssAddToCart = ref<any>()

const show = () => {
  visible.value = true
}

const hide = () => {
  visible.value = false
}

const setProduct = async (value: CustomSpu[]) => {
  if (dssAddToCart.value) {
    await getThemeCustomSpuData(value[0].dss_theme_id!).then((res:any) => {
      if(res.customSpus)
      dssAddToCart.value.reset()
      dssAddToCart.value.setProduct(res.customSpus,value[0].spu.category_id)
    })
  }
}

defineExpose({
  show,
  hide,
  setProduct
})

const onAdd = () => {
  if (dssAddToCart.value) {
    dssAddToCart.value.addProduct().then(() => {
      dssAddToCart.value.reset()
      visible.value = false
    }).catch(() => { })
  }
}

const onReset = () => {
  if (dssAddToCart.value) {
    dssAddToCart.value.reset()
  }
}

</script>
<style scoped lang="less"></style>
